import {FC, useState, useEffect, Fragment} from 'react'
import Button from 'react-bootstrap/Button'
import {Modal} from 'react-bootstrap'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'

const api = new Api()

type Props = {
  showFormModal: boolean
  handleCloseFormModal: any
  formData: any
}

const FormPage: FC<Props> = ({showFormModal, handleCloseFormModal, formData}) => {
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [data, setData] = useState<any>([])
  const [errors, setErrors] = useState<any>({})
  const [selectedRole, setSelectedRole] = useState<any>()

  const [roleToModule, setRoleToModule] = useState<any>([])

  const [allModule, setAllModule] = useState<any>([])
  const [showAssignModuleToRole, setShowAssignModuleToRole] = useState(false)

  useEffect(() => {
    setShow(showFormModal)

    if (showFormModal) {
      getAllModule()
    }

    if (formData) {
      setFormValue(formData)
      toggleAssignModuleToRole(formData?.id)
    }
  }, [showFormModal])

  const getAllModule = (params = {}) => {
    api
      .getModules({...params})
      .then((response: any) => {
        const data = response.data.data
        setAllModule(data)
      })
      .catch((error: any) => {
      })
  }

  const handleInput = (e: any, name: string) => {
    setFormValue({...formValue, [name]: e.target.value})
  }

  const handleClose = () => {
    setFormValue({})
    handleCloseFormModal(false)
    setShow(false)
    setErrors({})
  }

  const toggleAssignModuleToRole = (roleId: string = '') => {
    setShowAssignModuleToRole(!showAssignModuleToRole)

    getAllModule()
    if (roleId) {
      getRoleModule(roleId)
    }

    setSelectedRole(roleId ?? '')
  }

  const getRoleModule = async (id: any) => {
    api
      .getRoleModule(id)
      .then((response: any) => {
        const data = response.data

        //   const listed = roleModule.data.modules
        //   setRoleToModule(listed)
      })
      .catch((error: any) => {
      })

    // setLoad(true)
    // try {
    //   const roleModule: any = await MasterServices.getRoleModule({id: id})
    //   const listed = roleModule.data.modules
    //   setRoleToModule(listed)
    //   setLoad(false)
    // } catch (error) {
    // }
  }

  const store = () => {
    // const formData = new FormData(e.target)
    // const formProps = Object.fromEntries(formData)
    // let module = Object.keys(formProps).length == 0 ? [] : formProps
    // try {
    //   setSubmit(true)
    //   e?.preventDefault()
    //   await MasterServices.updateModule({id: selectedRole, module})
    //   toast.success(`Berhasil Update Module`)
    //   toggleAssignModuleToRole()
    //   setSubmit(false)
    // } catch (error) {
    //   setSubmit(false)
    // } finally {
    //   setSubmit(false)
    // }
  }

  const findChecked = (id: any) => {
    return roleToModule.find((object: any) => object.modules_id == id)
  }

  const handleChecked = (id: any) => {
    let module = roleToModule.filter((object: any) => object.modules_id != id)
    setRoleToModule(module)
  }

  const handleSubmit = () => {
    store()
  }

  return (
    <Modal show={show} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Module</Modal.Title>
      </Modal.Header>
      <div>
        <Modal.Body>
          {loading
            ? 'Loading...'
            : Object.keys(data).map((key, index) => {
                return (
                  <Fragment key={index}>
                    <div key={`inline-checkbox`} className='mb-8'>
                      {allModule[key]?.map((item: any, i: any) => {
                        return (
                          <div className='row' key={i}>
                            <div className='col-md-6'>
                              <div className='d-grid gap-2 d-md-flex'>
                                <input
                                  type='checkbox'
                                  name={item.modules_id}
                                  value={item.modules_id}
                                  // checked={findChecked(item.modules_id)}
                                  // onChange={() => handleChecked(item.modules_id)}
                                />
                                <label>{item.modules_description}</label>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </Fragment>
                )
              })}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className='btn btn-sm btn-secondary'
            onClick={() => handleClose()}
            disabled={loading}
          >
            Batalkan
          </Button>
          <Button className='btn btn-sm btn-primary' type='submit' disabled={loading}>
            {loading ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

const FormModuleModal: FC<Props> = ({showFormModal, handleCloseFormModal, formData}) => {
  return (
    <FormPage
      showFormModal={showFormModal}
      handleCloseFormModal={handleCloseFormModal}
      formData={formData}
    />
  )
}

export default FormModuleModal
